export default __webpack_public_path__ + "static/confused-group-scientists-288eacb82b342714a71496e93c160689.png";